export default __webpack_public_path__ + "static/media/硝酸盐（总氮）分析仪.73a5f184.png";